import { NavigateOptions, useNavigate } from "react-router-dom";
import { AppRoutePathTy } from "../config/path";


const useAppNavigation = () => {
  const navigate = useNavigate();

  /**
   * Navigates to a specified route with optional parameters and options.
   * @param path - The base route path.
   * @param params - Optional parameters to replace placeholders in the path.
   * @param isSibling - If true, the navigation is relative to the current route's sibling.
   * @param options - Additional navigation options.
   */
  const goNextPage = ({
    path,
    params,
    isSibling = false,
    options,
  }: {
    path: AppRoutePathTy;
    params?: Record<string, string | number | boolean>;
    isSibling?: boolean;
    options?: NavigateOptions;
  }) => {
    // Determine the target path based on sibling navigation
    const targetPath = isSibling ? `../${path}` : path;

    // Replace path parameters in the target path with provided values
    const transformedPath = params ? replacePathParams(targetPath, params) : targetPath;

    navigate(transformedPath, { ...options });
  };

  return goNextPage;
};

function replacePathParams(path: string, params: Record<string, string | number | boolean>): string {
  return path.replace(/:([a-zA-Z_]\w*)/g, (_, key) => {
    return params[key] !== undefined ? encodeURIComponent(params[key].toString()) : `:${key}`;
  });
}

export default useAppNavigation;